<template>
  <q-tabs
    v-model="currentValue"
    :vertical="vertical"
    :dense="dense"
    active-color="primary"
    indicator-color="primary"
    :align="align"
    no-caps
    inline-label
    class="mb-md"
  >
    <slot>
      <Tab
        v-for="item in items"
        :key="item.value"
        :name="item.value"
        :label="item.label"
        :icon="item.icon"
      />
    </slot>
  </q-tabs>
</template>

<script>
/*
 * items: {value: String, label: String, icon: String}
 */
import Tab from './Tab.vue';

export default {
  name: 'Tabs',
  components: {
    Tab,
  },
  props: {
    value: {
      type: String,
    },
    items: {
      type: Array,
    },
    vertical: {
      type: Boolean,
    },
    dense: {
      type: Boolean,
    },
    align: {
      type: String,
      default: 'left',
    },
  },
  computed: {
    currentValue: {
      set(val) {
        this.$emit('input', val);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>

<style scoped></style>
